/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { TTableColumnCell } from '../../../types';
import { TableCell } from '../index';
import { StyledIconButtonCell } from './IconButtonCellStyled';
import { TTableCellIconButton } from './types';

function TableCellIconButton<D extends object>(cell: TTableCellIconButton<D>): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: (props) =>
            TableCell(props)({
                render: ({ row }) => {
                    const { children, onClick } = cell(row);
                    return <StyledIconButtonCell onClick={onClick}>{children}</StyledIconButtonCell>;
                },
            }),
    };
}

export default TableCellIconButton;
